import apiClient from './api';

/**
 * Release Note API Service
 * SAP release notes (manual activities, deprecations, etc.) are entered
 * manually per release, so most releases will have none.
 */
export const releaseNoteApi = {
  /**
   * Get the release note for a release version.
   * @param {string} release - Release version (e.g., "2608")
   * @returns {Promise} Response with data: note object, or data: null if none exists
   */
  getByRelease: (release) => {
    return apiClient.get(`/api/release-notes/${release}`);
  },
};

export default releaseNoteApi;
